/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CostDataFilters } from '../models/CostDataFilters';
import { CostUnit } from '../models/CostUnit';
import { TimePeriod } from '../models/TimePeriod';

export class QueryCostDataRequest {
  'costUnit'?: CostUnit;
  'timePeriod': TimePeriod;
  /**
  * Granularity for cost aggregation
  */
  'granularity'?: QueryCostDataRequestGranularityEnum;
  'filters'?: CostDataFilters;
  /**
  * Group results by specified dimensions
  */
  'groupBy'?: QueryCostDataRequestGroupByEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "costUnit",
      "baseName": "costUnit",
      "type": "CostUnit",
      "format": ""
    },
    {
      "name": "timePeriod",
      "baseName": "timePeriod",
      "type": "TimePeriod",
      "format": ""
    },
    {
      "name": "granularity",
      "baseName": "granularity",
      "type": "QueryCostDataRequestGranularityEnum",
      "format": ""
    },
    {
      "name": "filters",
      "baseName": "filters",
      "type": "CostDataFilters",
      "format": ""
    },
    {
      "name": "groupBy",
      "baseName": "groupBy",
      "type": "QueryCostDataRequestGroupByEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return QueryCostDataRequest.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum QueryCostDataRequestGranularityEnum {
  Hourly = 'HOURLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Total = 'TOTAL'
}
export enum QueryCostDataRequestGroupByEnum {
  SourceAccount = 'SOURCE_ACCOUNT',
  CloudProvider = 'CLOUD_PROVIDER',
  ResourceType = 'RESOURCE_TYPE',
  ResourceId = 'RESOURCE_ID'
}

